document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
        if (sessionStorage.getItem('duchess-open-bundle-cart') === 'true') {
          sessionStorage.removeItem('duchess-open-bundle-cart');
          this.$nextTick(() => Alpine.store('modals').open('cart'));
        }
      },
    };
  });
});

document.addEventListener('biscuits--add-to-cart-success', () => {
  sessionStorage.setItem('duchess-open-bundle-cart', 'true');
  window.location.reload();
});
